<div *ngIf="active" [ngClass]="'cs-step-container'" [class]="styleClass">
   <ng-content></ng-content>
</div>